import React, { useState } from 'react';
import './App.css';

type ChipProps = {
  children: React.ReactNode;
  selected?: boolean;
  onClick?: () => void;
};

export default function Chip({ children, selected, onClick }: ChipProps) {
  return (
    <button
      className={`chip ${selected ? "chipSelected" : ""}`}
      onClick={onClick}
      type="button"
    >
      {children}
    </button>
  );
}